import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-photo-gallery',
    imports: [],
    templateUrl: './photo-gallery.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './photo-gallery.component.scss'
})
export class PhotoGalleryComponent {

}
